import React from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { BrowserRouter } from 'react-router-dom';
import App from './App/App';
import { theme } from './theme';

const Index = () => {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <StyledThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </StyledThemeProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

const root = createRoot(document.getElementById('root'));
root.render(<Index />);
